import React, { useState } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    Avatar,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const EditProjectRates = ({ open, onClose }) => {

    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>Edit project rates</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>

                    <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', fontFamily:'Manrope' }}>View and edit Nikita’s project hourly rates for Nikita's Organization's Project. If no project rates are entered, the organization level rates listed on Nikita’s profile will apply. <a style={{ color: '#0076FE', textDecoration: 'underline' }}>Learn more</a></Typography>
                    <Box sx={{ margin: '24px auto' }}>
                        <Typography fontWeight="400" sx={{ fontSize: '14px', color: '#000', fontWeight: '600', fontFamily:'Manrope' }}>Member</Typography>
                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                            <Avatar sx={{ fontSize: '14px', background: '#0067C7' }}>
                                {/* {!user.image && getInitials(user.name)} */}
                                <img src="https://randomuser.me/api/portraits/women/68.jpg" style={{
                                    height: '46px', width: '46px',
                                    backgroundSize: 'cover', objectFit: 'cover'
                                }} alt='project icon' className="img-fluid" />
                            </Avatar>
                            <Box>
                                <Typography fontWeight="bold" sx={{ fontSize: '16px', color: '#1A1F36', fontWeight: '600', fontFamily:'Manrope' }}>Vansh Saini</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C', fontFamily:'Manrope' }}>
                                    Social Media Strategist
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily:'Manrope' }}>Pay rate</Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '4px' }}>
                            <TextField fullWidth placeholder="Copy of Accounts" variant="outlined" margin="normal"
                                sx={{
                                    marginTop: '0', fontFamily:'Manrope', '& .MuiOutlinedInput-root': {
                                        height: '40px', fontSize: '14px', color: '#64748B', fontFamily:'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily:'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily:'Manrope' },
                                }} />
                            <span style={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily:'Manrope' }}>USD/hr</span>
                        </Box>
                        <Typography sx={{ fontSize: '12px', color: '#64748B', fontWeight: '400', margin: '0', fontFamily:'Manrope' }}>The amount used to pay Nikita Gupta for their work on the project.</Typography>
                    </Box>

                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily:'Manrope' }}>Bill rate</Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '4px' }}>
                            <TextField fullWidth placeholder="Copy of Accounts" variant="outlined" margin="normal"
                                sx={{
                                    marginTop: '0', fontFamily:'Manrope', '& .MuiOutlinedInput-root': {
                                        height: '40px', fontSize: '14px', color: '#64748B', fontFamily:'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily:'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily:'Manrope' },
                                }} />
                            <span style={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily:'Manrope' }}>USD/hr</span>
                        </Box>
                        <Typography sx={{ fontSize: '12px', color: '#64748B', fontWeight: '400', margin: '0', fontFamily:'Manrope' }}>The amount used to bill clients for Nikita Gupta’s work on the project.</Typography>
                    </Box>







                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily:'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default EditProjectRates;
